import { cva } from 'class-variance-authority';

// Always white background with proper border (using design system)
export const alertCoreVariants = cva('bg-background border-border');
